<template>
  <div :class="{'list-view-filters container': !isFromDashboard}">
    <div class="container">
      <list-view-filter-base
        v-for="filterElement in listView.filterElementsArray"
        :filter-element="filterElement"
        :key="filterElement.id"
      ></list-view-filter-base>

      <advanced-filter
          v-if="isFormability"
          :referencable-control-container="advancedFilterReferencableControlContainer"
          :show-section-divider="listView.hasFilterElements"
      ></advanced-filter>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import ListView from "../../../common/models/listViews/listView";
  import PublishedListView from "../../../common/models/listViews/publishedListView";
  import AdvancedFilter from "../../analyst_dashboard/components/listView/common/advanced-filter.vue";

  export default Vue.extend({
    components: {
      AdvancedFilter,
    },
    props: {
      listView: {
        type: Object as () => ListView | PublishedListView,
        required: true,
      }
    },
    computed: {
      isPreview(): boolean {
        return !this.selectedPublishedListView;
      },
      isFromDashboard(): boolean {
        return this.$router.currentRoute.query['from_dashboard_id'];
      },
      advancedFilterReferencableControlContainer() {
        if (this.isPreview) {
          return this.listView.object_model;
        }

        return this.selectedPublishedListView.publishedObjectModel;
      },
    },
  });
</script>